<template>
  <div class="home">
    <h2>Test Request for combination</h2>

    <b-container fluid>
      <b-form>
        <b-form-group
          id="newTestRequestInputGroup1"
          label="App installation GUID:"
          label-for="newTestRequestInput1"
        >
          <b-form-input
            id="newTestRequestInput1"
            type="text"
            v-model="form.appInstallId"
            placeholder="Enter installation GUID or leave empty"
          />
        </b-form-group>

        <b-form-group
          id="newTestRequestInputGroup2"
          label="IP address:"
          label-for="newTestRequestInput2"
        >
          <b-form-input
            id="newTestRequestInput2"
            type="text"
            v-model="form.ipAddress"
            placeholder="Enter IP address or leave empty"
          />
        </b-form-group>

        <b-form-group
          id="newTestRequestInputGroup3"
          label="Whitelabel name:"
          label-for="newTestRequestInput3"
        >
          <b-form-input
            id="newTestRequestInput3"
            type="text"
            v-model="form.whitelabel"
            placeholder="Enter whitelabel name or leave empty"
          />
        </b-form-group>

        <b-form-group
          id="newTestRequestInputGroup4"
          label="Platform name:"
          label-for="newTestRequestInput4"
        >
          <b-form-input
            id="newTestRequestInput4"
            type="text"
            v-model="form.platform"
            placeholder="Enter platform name or leave empty"
          />
        </b-form-group>
        <b-form-group
          id="newTestRequestInputGroup5"
          label="Resolution:"
          label-for="newTestRequestInput5"
        >
          <b-form-input
            id="newTestRequestInput5"
            type="text"
            v-model="form.resolution"
            placeholder="Enter resolution or leave empty"
          />
        </b-form-group>
        <b-button @click="sendTestRequest" variant="primary">
          Send
        </b-button>
      </b-form>
    </b-container>
  </div>
</template>

<script>
const originalForm = {
  appInstallId: null,
  ipAddress: null,
  whitelabel: null,
  platform: null,
  resolution: null
};

export default {
  data() {
    return {
      form: {
        ...originalForm
      }
    };
  },
  methods: {
    sendTestRequest() {
      const platformData = {
        platform: { name: this.form.platform }
      };

      if (!platformData.platform.name || platformData.platform.name === '') {
        delete platformData.platform;
      }

      window.open(
        `${
          this.$store.state.appConfig.backendUrl
        }/v1/combination/get?platform=${JSON.stringify(
          platformData
        )}&ipAddress=${this.form.ipAddress || ''}&appInstallId=${this.form
          .appInstallId || ''}&whitelabel=${this.form.whitelabel ||
          ''}&resolution=${this.form.resolution || ''}`,
        '_blank'
      );
      return false;
    }
  }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.btn {
  font-size: 0.8rem;
}
</style>
